module.exports = __webpack_public_path__ + "img/logo_edit_bk.66f78553.png";